import type { SalesOpportunity } from "@color-finder/color-finder-api/models";
import type { AxiosRequestConfig } from "axios";
import { useMemo } from "react";
import { type RequestState, useAuthenticatedRequest } from "./request";

export function useOpportunities(
  query: string | undefined,
  limit: number | undefined,
  shouldLoad?: boolean,
): RequestState<Array<SalesOpportunity>> {
  const config = useMemo(
    () => createRequestConfig(query, limit),
    [query, limit],
  );
  return useAuthenticatedRequest<Array<SalesOpportunity>>(
    `/v0/sales-opportunities`,
    config,
    shouldLoad,
  );
}

function createRequestConfig(
  id: string | undefined,
  limit: number | undefined,
): AxiosRequestConfig {
  const config = { params: new URLSearchParams() };
  if (id) {
    config.params.set("query", id);
  }
  if (limit) {
    config.params.set("limit", limit.toString());
  }
  config.params.set("cache", Date.now().toString());
  return config;
}
